import BaseIcon from "assets/icons/invoice/BaseIcon";
import DetailsIcon from "assets/icons/invoice/TableStyleIcon";
import TableIcon from "assets/icons/invoice/TableIcon";
import { InvoiceIconType } from "assets/icons/invoice/invoice.icon";
import { factorPatternType } from "components/Factor/factorView/patternSetting/FactorSettingPattern";

export interface PrintSettingsTab {
  Icon: ({ active }: InvoiceIconType) => JSX.Element;
  title: string;
  state: factorPatternType;
}

const printSettingsTabs: PrintSettingsTab[] = [
  {
    Icon: BaseIcon,
    title: "پایه",
    state: "baseSetting",
  },
  {
    Icon: DetailsIcon,
    title: "مشخصات",
    state: "detailsSetting",
  },
  {
    Icon: TableIcon,
    title: "جدول",
    state: "tableSetting",
  },
];

export default printSettingsTabs;
